import { NavigableElement } from '../../../CfDataGridProps';
import { ValueGetter } from '../../DataGridTableView/CfDataGridTableViewProps';
import { CfDataGridCellProps } from './CfDataGridCell';
import { CfDataGridCellByIdProps } from './CfDataGridCellById';

// Types
export interface CfDataGridCellsBaseProps {
  itemIndex: number;
  filterText: string | undefined;
  setNavigableElement: (navigableElement: NavigableElement, rowIndex: number, columnIndex: number) => void;
}

export interface CfDataGridCellBaseProps<TItem> extends CfDataGridCellsBaseProps {
  columnIndex: number;
  getter: ValueGetter<TItem>;
}

export interface CfDataGridCellByIdPropsPassThru<TItem, TAppState> extends CfDataGridCellBaseProps<TItem> {
  item: TItem | undefined;
  // Properties to delete...
  itemId?: string | undefined;
  previousItemId?: string | undefined;
  itemSelector?: (itemId: string, store: TAppState) => TItem | undefined;
  useSelector?: (itemSelector: (state: TAppState) => TItem | undefined) => TItem | undefined;
}

// Functions
export function getCellPropsFromCellPropsById<TItem, TAppState>(
  props: CfDataGridCellByIdProps<TItem, TAppState>,
  item: TItem | undefined
): CfDataGridCellProps<TItem> {
  const augmentedProps: CfDataGridCellByIdPropsPassThru<TItem, TAppState> = { item, ...props };
  delete augmentedProps.itemId;
  delete augmentedProps.itemSelector;
  delete augmentedProps.useSelector;
  return augmentedProps;
}
